// Deps
import slick from 'slick-carousel';

/**
 * Variables
 */

const $tweets         = document.getElementById( 'listTweets' );
const $sectionTweets  = document.getElementById( 'sectionTweets' );
const $sectionHeading = document.getElementById( 'sectionHeadingTweets' );

let ticking = false;
let initialized = false;
let globalBreakpoint = null;

let translateY = 0;
let height = 0;

/**
 * Functions
 */

/**
 * Gets the transformed values of an element.
 */
const getTransform3d = ( el ) => {
	const transform = window.getComputedStyle( el, null ).getPropertyValue( 'transform' );
	const results = transform.match( /matrix(?:(3d)\(-{0,1}\d+(?:, -{0,1}\d+)*(?:, (-{0,1}\d+))(?:, (-{0,1}\d+))(?:, (-{0,1}\d+)), -{0,1}\d+\)|\(-{0,1}\d+(?:, -{0,1}\d+)*(?:, (-{0,1}\d+))(?:, (-{0,1}\d+))\))/ );
	let resultsObject = {};

	if ( ! results ) {
		resultsObject = { x: 0, y: 0, z: 0 };
	} else if ( '3d' === results[1]) {
		resultsObject = {
			x: parseFloat( results[2]),
			y: parseFloat( results[3]),
			z: parseFloat( results[4])
		};
	} else {
		resultsObject = {
			x: parseFloat( results[5]),
			y: parseFloat( results[6]),
			z: 0
		};
	}

	return resultsObject;
};

/**
 * The window resize event.
 * Used mainly so we can throttle it via rAF.
 */
const windowResize = function() {

	// Check if we have a function running.
	if ( ! ticking ) {
		ticking = true;

		// Get a new frame and run the function.
		requestAnimationFrame( tweetsResize );
	}
};

/**
 * Checks the window size to create or destroy the carousel.
 */
const tweetsResize = function() {
	const isSlickInitialized = $tweets.classList.contains( 'slick-initialized' );

	// Match the screen if it is smaller than 960px
	if ( isSlickInitialized ) {
		tweetsSectionResize();
		tweetsCreateSlick();
	}

	// Ready for another resize event.
	ticking = false;
};

const tweetsSectionResize = function() {
	const breakpoint = window.matchMedia( getBreakpoint() ).matches;
	const $heightBaseElem = document.querySelector( '.twitter-height-base' );
	const height = $heightBaseElem.offsetHeight;

	if ( breakpoint ) {
		$sectionTweets.style.height = `${height}px`;
		$sectionTweets.classList.add( 'active' );
	} else {
		$sectionTweets.style.height = 'auto';
		$sectionTweets.classList.remove( 'active' );
	}
};

const inIframe = function() {
    if ( $( '#amcn-iframe' ).length ) {
        return true;
    }
	try {
		return window.location !== window.parent.location;
	} catch ( e ) {
		return true;
	}
};

const getBreakpoint = function() {
	if ( inIframe() ) {
		return '(min-width: 0px)';
	} else {
		return '(min-width: 960px)';
	}
};

/**
 * Calculate number of tweets that can fit screen height.
 *
 * @return {number}
 */
const getSlidesToShowCount = function() {
	let slides = $sectionTweets.querySelectorAll( '.list--tweets > li' );

	slides = [].map.call( slides, function( slide ) {
		return jQuery( slide ).height();
	});

	const containerHeight = jQuery( $sectionTweets ).height() - jQuery( $sectionHeading ).height();

	let height = 0;
	let minCount = slides.length;
	let currCount = 0;
	let first = 0;
	let i;

	for ( i = 0; i < slides.length; i++ ) {
		if ( height + slides[i] <= containerHeight ) {
			height += slides[i];
			currCount++;

		} else {
			minCount = Math.min( minCount, currCount );
			height += slides[i];
			currCount++;

			while ( height > containerHeight ) {
				height -= slides[first];
				first++;
				currCount--;
			}
		}
	}

	minCount = Math.min( minCount, currCount );

	// Ensure that at least one slide is visible even is there is too less space for any single slide.
	return Math.max( minCount, 1 );
};

/**
 * Creates the slick carousel.
 */
const tweetsCreateSlick = function() {
	const defaults = {
		arrows: true,
		appendArrows: '#slickNav',
		prevArrow: '<button type="button" class="slick-arrow--prev" disabled><span class="screen-reader-text">Previous</span></button>',
		nextArrow: '<button type="button" class="slick-arrow--next"><span class="screen-reader-text">Next</span></button>',
		dots: true,
		autoplay: false
	};
	let filter = false;
	let options = {};
	let settings;
	const breakpoint = window.matchMedia( getBreakpoint() ).matches;

	// Prevent this function from firing too much.
	// This should only continue if the breakpoint was hit.
	if ( breakpoint === globalBreakpoint ) {
		return;
	}

	// Set options and filtering based on breakpoint.
	if ( breakpoint ) {
		const slidesToShow = getSlidesToShowCount();

		options = {
			vertical: true,
			slidesToShow: slidesToShow,
			slidesToScroll: inIframe() ? 1 : slidesToShow,
			infinite: false,
			speed: 0,
			useCSS: false
		};
	} else {
		options = {
			slidesToScroll: 1,
			slidesToShow: 1,
			adaptiveHeight: true
		};

		filter = true;
	}


	// Is there a current slider?
	// We need to reset before destroying it.
	if ( initialized ) {
		jQuery( $tweets ).slick( 'slickUnfilter' );
		jQuery( $tweets ).slick( 'unslick' );
	}

	// Merge the defaults with breakpoint specific options
	settings = Object.assign({}, defaults, options );

	// Create a new slick slider
	jQuery( $tweets ).slick( settings );

	// Filter the slider, if specified.
	if ( filter ) {
		jQuery( $tweets ).slick( 'slickFilter', ( index ) => {
			return 10 > index;
		});
	}

	// Update the global variable so we can avoid extra calls.
	globalBreakpoint = breakpoint;
};

/**
 * Updates variables for transitions.
 */
const tweetsBeforeChange = function() {

	// Make sure the slider is ready.
	if ( ! initialized ) {
		return;
	}

	// Check breakpoint
	if ( ! window.matchMedia( getBreakpoint() ).matches ) {
		return;
	}

	const $slickList  = document.querySelector( '.list--tweets.slick-vertical .slick-list' );
	const $slickTrack = $slickList.querySelector( '.slick-track' );
	const transform   = getTransform3d( $slickTrack );

	height = jQuery( $slickList ).outerHeight();
	translateY = transform.y;
};

/**
 * Updates the button states on the slider.
 *
 * @param {Object} event The event object.
 * @param {*Object} slick The slick slider object.
 */
const tweetsAfterChange = function( event, slick ) {

	// Make sure the slider is ready.
	if ( ! initialized ) {
		return;
	}

	tweetsUpdateArrows( slick );
};

/**
 * Handles transitions when slider is vertical.
 */
const tweetsSetPosition = function() {

	// Make sure the slider is ready.
	if ( ! initialized ) {
		return;
	}

	// Check breakpoint
	if ( ! window.matchMedia( '(min-width: 0px)' ).matches ) {
		return;
	}

	const $slickList    = document.querySelector( '.list--tweets.slick-vertical .slick-list' );
	const $slickTrack   = $tweets.querySelector( '.slick-track' );
	const $activeSlides = $slickTrack.querySelectorAll( '.slick-active' );

	// Make sure it exists as a vertical.
	if ( ! $slickList ) {
		return;
	}

	let totalHeight     = 0;
	let totalTranslateY = 0;

	totalTranslateY = jQuery( $activeSlides[0]).position().top;

	if ( totalTranslateY === translateY ) {
		return;
	}

	// Reset
	$slickTrack.style.transform = `translate(0px, ${translateY}px)`;

	//Some fix to solve additional space after finished scroll in main page
	if ( 0 !== totalTranslateY ) {
		if ( jQuery( $slickTrack ).find( '.slick-slide' ).length -  ( jQuery( $slickTrack ).find( '.slick-active' ).last().index() + 1 ) < $activeSlides.length ) {
			totalTranslateY =  -( jQuery( $slickTrack ).height() - jQuery( $tweets ).height() );
		} else {
			totalTranslateY = -totalTranslateY;
		}
	}


	// New position
	$slickTrack.style.transform = `translate(0px, ${totalTranslateY}px)`;
};

/**
 * Updates the arrows on the slider.
 *
 * @param {Object} slick The slick slider object.
 */
const tweetsUpdateArrows = function( slick ) {

	// Synchronize "disabled" attribute with ".slick-disabled" class.
	slick.$prevArrow.prop( 'disabled', slick.$prevArrow.hasClass( 'slick-disabled' ) );
	slick.$nextArrow.prop( 'disabled', slick.$nextArrow.hasClass( 'slick-disabled' ) );
};

/**
 * Variable so we can check if the slider is ready.
 */
const tweetsInit = function() {

	const $slickList = document.querySelector( '.list--tweets.slick-vertical .slick-list' );

	initialized = true;

	if ( $slickList ) {
		height = jQuery( $slickList ).outerHeight();
	}
};

/**
 * Tweets initialize function.
 * Sets up the functionality of the carousel.
 */
const tweetsCarouselInit = function() {

	// Check if the twitter section exists.
	if ( ! $tweets ) {
		return;
	}

	// Do an initial resize check.
	tweetsResize();

	// Binding
	window.addEventListener( 'resize', windowResize );
	jQuery( $tweets ).on( 'init', tweetsInit );
	jQuery( $tweets ).on( 'afterChange', tweetsAfterChange );

	jQuery( $tweets ).on( 'beforeChange', tweetsBeforeChange );
	jQuery( $tweets ).on( 'setPosition', tweetsSetPosition );

	// Add slick nav
	jQuery( $tweets ).after( '<div id="slickNav" class="slick-nav"></div>' );

	// Create the slider.
	tweetsSectionResize();
	tweetsCreateSlick();
};

export { tweetsCarouselInit };
